// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import HeatmapFilterTemplate from '@front/templates/HeatmapFilterTemplate.html';
import { NewContextMenuItemType } from '@shared/utils/ContextMenuUtils';
import { ContainerControl } from '../../elements/ContainerControl';
export class HeatmapFilter extends ContainerControl {
    constructor() {
        super();
    }
    oninit() {
        super.oninit();
        this.observe('scaleMultiplier', this.onScaleMultiplierChanged);
        this.on('scaleMultiplierSelectedItemChanged', this.onScaleMultiplierSelectedItemChanged);
        this.on('intervalClicked', this.onIntervalClicked);
    }
    onScaleMultiplierChanged() {
        const items = this.get('scaleMultiplierItems');
        const scaleMultiplier = this.get('scaleMultiplier');
        for (let i = 0; i < items.length; i++) {
            if (items[i].value === scaleMultiplier) {
                void this.set('scaleMultiplierSelectedItem', items[i]);
                break;
            }
        }
    }
    onScaleMultiplierSelectedItemChanged() {
        const scaleMultiplierCombobox = this.findComponent('terceraComboBox');
        if (!isNullOrUndefined(scaleMultiplierCombobox)) {
            const selectedItem = scaleMultiplierCombobox.get('selectedItem');
            this.fire('scaleMultiplierChanged', selectedItem.value);
        }
    }
    onIntervalClicked(_sender, interval) {
        interval.IsSelected = !interval.IsSelected;
        void this.update();
        this.fire('scaleFilterChanged');
    }
}
ContainerControl.extendWith(HeatmapFilter, {
    template: HeatmapFilterTemplate,
    data: function () {
        return {
            intervals: [],
            scaleMultiplierItems: [
                { type: NewContextMenuItemType.Default, text: 'x0.1', value: 0.1 },
                { type: NewContextMenuItemType.Default, text: 'x0.2', value: 0.2 },
                { type: NewContextMenuItemType.Default, text: 'x0.25', value: 0.25 },
                { type: NewContextMenuItemType.Default, text: 'x0.5', value: 0.5 },
                { type: NewContextMenuItemType.Default, text: 'x1', value: 1 },
                { type: NewContextMenuItemType.Default, text: 'x2', value: 2 },
                { type: NewContextMenuItemType.Default, text: 'x3', value: 3 },
                { type: NewContextMenuItemType.Default, text: 'x5', value: 5 },
                { type: NewContextMenuItemType.Default, text: 'x10', value: 10 }
            ],
            scaleMultiplierSelectedItem: null,
            scaleMultiplier: undefined,
            foregroundColor: ''
        };
    }
});
